module.exports = __webpack_public_path__ + "h5/img/detail_w.0f14b4d5.png";